import ParseDBF from "../../lib/ParseDBF";
import {createRequest} from "../../components/common/helpers/RequestHelpers";
import {NotificationManager} from "react-notifications";

const { readString } = require("react-papaparse");

const accountingRequest = createRequest({
  urlPath: '/settings/accounting',
  // local: true
})

const Types = {
	ACCOUNTING_IMPORT_FILE: "ACCOUNTING_IMPORT_FILE",
	ACCOUNTING_GET_DATA: "ACCOUNTING_GET_DATA",
	ACCOUNTING_FILE_DATA_LOADED: "ACCOUNTING_FILE_DATA_LOADED",
	ACCOUNTING_CLEAR_FILE: "ACCOUNTING_CLEAR_FILE",
	ACCOUNTING_SAVE_LEDGERS: "ACCOUNTING_SAVE_LEDGERS",
	ACCOUNTING_UPDATE_LEDGERS: "ACCOUNTING_UPDATE_LEDGERS",
	ACCOUNTING_SAVE_COST_CENTERS: "ACCOUNTING_SAVE_COST_CENTERS",
	ACCOUNTING_UPDATE_COST_CENTERS: "ACCOUNTING_UPDATE_COST_CENTERS",
	ACCOUNTING_UPDATE_JOURNALS: "ACCOUNTING_UPDATE_JOURNALS",
	ACCOUNTING_SAVE_JOURNALS: "ACCOUNTING_SAVE_JOURNALS",
	ACCOUNTING_SAVE_CONDITIONS: "ACCOUNTING_SAVE_CONDITIONS",
	ACCOUNTING_UPDATE_JOURNAL_CONDITION: "ACCOUNTING_UPDATE_JOURNAL_CONDITION",
};


const toBuffer = (ab) => {
	var buf = Buffer.alloc(ab.byteLength);
	var view = new Uint8Array(ab);
	for (var i = 0; i < buf.length; ++i) {
		buf[i] = view[i];
	}
	return buf;
};

const accountingImportSetFileName = (fileName) => ({
	type: Types.ACCOUNTING_IMPORT_FILE,
	fileName,
});

const accountingFileDataLoaded = ({ fields, data }) => ({
	type: Types.ACCOUNTING_FILE_DATA_LOADED,
	fields,
	data,
});

const accountingClearFile = () => ({
	type: Types.ACCOUNTING_CLEAR_FILE,
});

const handleAccountingFiles = (files) => {
	return (dispatch) => {
		if (files != null) {
			let reader = new FileReader();
			let file = files[0];

			dispatch(accountingImportSetFileName(file.name));

			const fileParts = file.name.toLowerCase().split(".");
			const fileExtension = fileParts[fileParts.length - 1];

			reader.onload = () => {
				switch (fileExtension) {
					case "csv":
						{
							const parsedCSV = readString(reader.result, { header: true, skipEmptyLines: true });

							dispatch(
								accountingFileDataLoaded({
									fields: parsedCSV.meta.fields,
									data: parsedCSV.data,
								}),
							);
						}
						break;
					default:
						{
							var buffer = toBuffer(reader.result);

							ParseDBF(buffer).then((data) => {
								dispatch(
									accountingFileDataLoaded({
										fields: data.fields,
										data: data.records,
									}),
								);
							});
						}
						break;
				}
			};

			if (fileExtension == "csv") {
				reader.readAsText(file);
			} else {
				reader.readAsArrayBuffer(file);
			}
		} else {
			dispatch(accountingImportSetFileName(null));
			dispatch(
				accountingFileDataLoaded({
					fields: null,
					data: null,
				}),
			);
		}
	};
};

const accountingSavedLedgers = (data) => ({
	type: Types.ACCOUNTING_SAVE_LEDGERS,
	data,
});

/**
 *
 * @param data
 * @returns {{data, type: string}}
 */
const accountingSaveLedgers = () => {

	return async (dispatch,getState) => {
		const state = getState()

		if (state.accounting.ledgers.dirty) {
			const body = state.accounting.ledgers.data
			console.log('accountingSaveLedgers',body)
			const {data: response} = await accountingRequest({
				method: 'POST',
				path: '/ledgers',
				body
			})

			dispatch(accountingSavedLedgers(response.data))
		} else {
			// show notification that no changes were made
			NotificationManager.success("No changes were made since last save", "Ledgers");
		}
	}

}

const updateLedgers = (data) => ({
	type: Types.ACCOUNTING_UPDATE_LEDGERS,
	data,
});

const accountingSavedCostCenters = (data) => ({
	type: Types.ACCOUNTING_SAVE_COST_CENTERS,
	data,
});

/**
 * This needs to save const centres by sending it to our API
 * @param data
 * @returns {{data, type: string}}
 */
const accountingSaveCostCenters = (data) => {

	return async (dispatch,getState) => {
		const state = getState()

		const body = state.accounting.costCenters.data

		if (state.accounting.costCenters.dirty) {

			const {data: response} = await accountingRequest({
				method: 'POST',
				path: '/cost-centers',
				body
			})

			dispatch(accountingSavedCostCenters(response.data))
		} else {
			// show notification that no changes were made
			NotificationManager.success("No changes were made since last save", "Cost Centers");
		}
	}
}


const accountingGetData = (data) => ({
	type: Types.ACCOUNTING_GET_DATA,
	data,
})


/**
 * This needs to save const centres by sending it to our API
 * @param data
 * @returns {{data, type: string}}
 */
const getData = () => {

	return async (dispatch) => {
		const {data} = await accountingRequest({
			method: 'GET',
			path: ''
		})

		dispatch(accountingGetData(data))
	}
}

const updateCostCenters = (data) => ({
	type: Types.ACCOUNTING_UPDATE_COST_CENTERS,
	data,
});

const accountingUpdateJournals = (selectedLevels) => ({
	type: Types.ACCOUNTING_UPDATE_JOURNALS,
	selectedLevels,
});

const accountingSavedJournals = (selectedLevels) => ({
	type: Types.ACCOUNTING_SAVE_JOURNALS,
	selectedLevels,
});

const accountingSaveJournals = () => {
	return async (dispatch, getState) => {
		const data = getState().accounting.journals.selectedLevels
		const {data: journalData} = await accountingRequest({
			method: 'POST',
			path: '/journals',
			body: data
		})

		// also save the conditions that are dirty
		const conditions = getState().accounting.journals.conditions.filter((condition) => condition.dirty);

		const {data: conditionsData} = await accountingRequest({
			method: 'POST',
			path: '/journal-conditions',
			body: conditions
		})

		dispatch(accountingSavedJournals(journalData))
	}

}

const accountingSaveConditions = (data) => ({
	type: Types.ACCOUNTING_SAVE_CONDITIONS,
	data,
});

const updateJournalCondition = (data) => ({
	type: Types.ACCOUNTING_UPDATE_JOURNAL_CONDITION,
	data,
});

const Actions = {
	handleAccountingFiles,
	accountingImportSetFileName,
	accountingFileDataLoaded,
	accountingClearFile,
	accountingSaveLedgers,
	updateLedgers,
	accountingSaveCostCenters,
	accountingUpdateJournals,
	accountingSaveJournals,
	accountingSaveConditions,
	updateCostCenters,
	updateJournalCondition,
	getData
};

export { Types, Actions };
